module.exports = __webpack_public_path__ + "img/76.c392de2f.jpg";